<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .signup {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: utils.in_rem(22px);
    align-self: stretch;
    .heading {
      color: black;
      text-align: center;
      font-family: "Gabarito", "Lato", sans-serif;
      font-size: 50px;
      font-style: normal;
      font-weight: 700;
      line-height: 130%;
    }

    .buttons {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: utils.in_rem(8px);
    }
  }
</style>

<script>
  import InlineNotification from "@sourcewhale/shared/svelte-design-system/components/atoms/InlineNotification.svelte";
  import { SvelteURLSearchParams } from "svelte/reactivity";
  import OauthButton from "./OauthButton.svelte";
  const params = new SvelteURLSearchParams(window.location.search);
  let paramError = $derived(params.get("error"));
</script>

<div class="signup">
  <span class="heading"
    >Get Started with Inbox Agent and Notetaker for Free</span
  >
  <div class="buttons">
    <OauthButton imageSrc="/assets/img/signup/google.png" provider="gcp" />
    <OauthButton imageSrc="/assets/img/signup/microsoft.png" provider="azure" />
    {#if paramError === "personalEmail"}
      <InlineNotification message="error" contrast="low" style="font-size:14px">
        Please sign up using your work email address
      </InlineNotification>
    {/if}
  </div>
</div>
